/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Tag, Tooltip } from '@blend/enterprise-components';
import { RoomStatus } from '../../../shared/constants/room';

const RoomStatusTooltipMapping: Record<string, string> = {
  DRAFT: 'Draft',
  PAUSED: 'Paused',
};

export const StatusCell: React.FC<{ value: RoomStatus }> = ({ value }) => {
  const shouldDisplayTag = value && (value === RoomStatus.DRAFT || value === RoomStatus.PAUSED);
  return (
    <div>
      {shouldDisplayTag && (
        <div>
          <Tooltip position="bottom" size="sm" text={RoomStatusTooltipMapping[value]}>
            <Tag
              text={value === RoomStatus.DRAFT ? 'DR' : 'PA'}
              theme={value === RoomStatus.DRAFT ? 'affirm' : 'warning'}
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};
